import './Titulo.css'

const Titulo = ({texto}) => {
    return (
        <div className="container-h4">
            <h4>{texto}</h4>
        </div>
    )
}

export default Titulo
